import { render, staticRenderFns } from "./LoadingModal.vue?vue&type=template&id=ed83dc70"
import script from "./LoadingModal.vue?vue&type=script&lang=js"
export * from "./LoadingModal.vue?vue&type=script&lang=js"
import style0 from "./LoadingModal.vue?vue&type=style&index=0&id=ed83dc70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports